module.exports = __webpack_public_path__ + "images/emoji/running.f96ea5ae0ceb2e0f8c4d.png";